module.exports = "/static/assets/a9021579cc12bc591ea0e2085374bee2.png";